import * as Yup from 'yup';

import { YZip } from 'utils/YupUtils';

export const YDisorderPage = Yup.object().shape({
  zip: YZip,
});
